let ALL_BRICKLINK_SOLID_COLORS = [
    {
        name: "White",
        hex: "#ffffff",
        id: 1,
    },
    {
        name: "Beige",
        hex: "#f7e6de",
        id: 49,
    },
    {
        name: "Light Gray",
        hex: "#d1d3d5",
        id: 99,
    },
    {
        name: "Silver",
        hex: "#a6a9aa",
        id: 86,
    },
    {
        name: "Gray",
        hex: "#8e9089",
        id: 9,
    },
    {
        name: "Magenta",
        hex: "#ec008c",
        id: 10,
    },
    {
        name: "Pink",
        hex: "#f55a74",
        id: 85,
    },
    {
        name: "Hot Pink",
        hex: "#f5547c",
        id: 11,
    },
    {
        name: "Orange",
        hex: "#ff6a13",
        id: 59,
    },
    //{
    //    name: "Pumpkin",
    //    hex: "#ff9016",
    //    id: 5,
    //},
    {
        name: "Gold",
        hex: "#e4bd68",
        id: 27,
    },
    {
        name: "Honey",
        hex: "#fec600",
        id: 220,
    },
    {
        name: "Yellow",
        hex: "#f4ee2a",
        id: 25,
    },
    {
        name: "Lime",
        hex: "#becf00",
        id: 26,
    },
    {
        name: "Green",
        hex: "#00ae42",
        id: 58,
    },
    {
        name: "Forest",
        hex: "#3f8e43",
        id: 88,
    },
    {
        name: "Bronze",
        hex: "#847d48",
        id: 8,
    },
    {
        name: "Cocoa",
        hex: "#6f5034",
        id: 120,
    },
    {
        name: "Brown",
        hex: "#9d432c",
        id: 69,
    },
    {
        name: "Maroon",
        hex: "#9d2235",
        id: 2,
    },
    {
        name: "Red",
        hex: "#c12e1f",
        id: 90,
    },
    {
        name: "Turquoise",
        hex: "#00b1b7",
        id: 28,
    },
    {
        name: "Cyan",
        hex: "#0086d6",
        id: 150,
    },
    {
        name: "Blue",
        hex: "#0a2989",
        id: 225,
    },
    {
        name: "Denim",
        hex: "#0056b8",
        id: 91,
    },
    {
        name: "Purple",
        hex: "#5e43b7",
        id: 106,
    },
    {
        name: "Indigo",
        hex: "#482960",
        id: 160,
    },
    {
        name: "Cool Gray",
        hex: "#5b6579",
        id: 29,
    },
    {
        name: "Dark Gray",
        hex: "#545454",
        id: 68,
    },
    {
        name: "Black",
        hex: "#000000",
        id: 165,
    },
    {
        name: "Ivory",
        hex: "#cbc6b8",
        id: 4,
    },
    {
        name: "Desert",
        hex: "#e8dbb7",
        id: 31,
    },
    {
        name: "Latte",
        hex: "#deb7a7",
        id: 110,
    },
    {
        name: "Caramel",
        hex: "#ae835b",
        id: 32,
    },
    {
        name: "Terracotta",
        hex: "#b15533",
        id: 96,
    },
    {
        name: "Dark Brown",
        hex: "#7d6556",
        id: 161,
    },
    {
        name: "Chocolate",
        hex: "#4d3324",
        id: 3,
    },
    {
        name: "Lavender",
        hex: "#ae96d4",
        id: 103,
    },
    {
        name: "Blush",
        hex: "#e8afcf",
        id: 33,
    },
    {
        name: "Mango",
        hex: "#ff9016", //previously f99431, replaced Pumpkin with Mango
        id: 35,
    },
    {
        name: "Lemon",
        hex: "#f7d959",
        id: 158,
    },
    {
        name: "Plum",
        hex: "#950051",
        id: 166,
    },
    {
        name: "Scarlet",
        hex: "#de4343",
        id: 76,
    },
    {
        name: "Dark Red",
        hex: "#bb3d43",
        id: 34,
    },
    {
        name: "Seaweed",
        hex: "#68724d",
        id: 155,
    },
    {
        name: "Grass",
        hex: "#61c680",
        id: 80,
    },
    {
        name: "Spring Green",
        hex: "#c2e189",
        id: 6,
    },
    {
        name: "Light Blue",
        hex: "#a3d8e1",
        id: 36,
    },
    {
        name: "Sky",
        hex: "#56b7e6",
        id: 37,
    },
    {
        name: "Celadon",
        hex: "#0078bf",
        id: 38,
    },
    {
        name: "Navy",
        hex: "#042f56",
        id: 48,
    },
    {
        name: "Aluminum",
        hex: "#9b9ea0",
        id: 39,
    },
    {
        name: "Granite",
        hex: "#757575",
        id: 40,
    },
    {
        name: "Coral",
        hex: "#f09a7e",
        id: 1710,
    },
    {
        name: "Olive",
        hex: "#777e71",
        id: 1711,
    },
    {
        name: "Mist",
        hex: "#5f778e",
        id: 1712,
    },
    {
        name: "Almond",
        hex: "#e4d0b0",
        id: 1713,
    },
    {
        name: "Tan",
        hex: "#f6bf8b",
        id: 1714,
    },
    {
        name: "Peanut",
        hex: "#bf9573",
        id: 1715,
    },
    {
        name: "Wood",
        hex: "#ab7449",
        id: 1716,
    },
    {
        name: "Storm",
        hex: "#2e4462",
        id: 1717,
    },
    {
        name: "Haze",
        hex: "#6191b4",
        id: 1718,
    },
    {
        name: "Frost",
        hex: "#edf0f2",
        id: 1719,
    },
    {
        name: "Cement",
        hex: "#697272",
        id: 1720,
    },
    {
        name: "Steel",
        hex: "#b2b8b8",
        id: 1721,
    },
    {
        name: "Slate",
        hex: "#616469",
        id: 1722,
    },
    {
        name: "Arctic",
        hex: "#d9dfe5",
        id: 1723,
    },
    {
        name: "Fossil",
        hex: "#8a8c94",
        id: 1724,
    },
    {
        name: "Concrete",
        hex: "#b7b7b5",
        id: 1725,
    },
    {
        name: "Clay",
        hex: "#f0ddc2",
        id: 1726,
    },
    {
        name: "Apricot",
        hex: "#fead77",
        id: 1727,
    },
    {
        name: "Sand",
        hex: "#edd5a6",
        id: 1728,
    },
    {
        name: "Bone",
        hex: "#d1c1a8",
        id: 1729,
    },
    {
        name: "Cream",
        hex: "#eed1a8",
        id: 1730,
    },
    {
        name: "Khaki",
        hex: "#f1d0b6",
        id: 1731,
    },
    {
        name: "Toffee",
        hex: "#a88d5d",
        id: 1732,
    },
];

const HEX_TO_COLOR_NAME = {};
ALL_BRICKLINK_SOLID_COLORS.forEach((color) => {
    HEX_TO_COLOR_NAME[color.hex] = color.name;
});

const COLOR_NAME_TO_ID = {};
ALL_BRICKLINK_SOLID_COLORS.forEach((color) => {
    COLOR_NAME_TO_ID[color.name] = color.id;
});

const KNOWN_BRICKLINK_STUD_COLOR_NAMES = [
    "Black",
    "Blue",
    "Bright Green",
    "Bright Light Yellow",
    "Bright Pink",
    "Brown",
    "Dark Blue",
    "Dark Bluish Gray",
    "Dark Brown",
    "Dark Gray",
    "Dark Orange",
    "Dark Pink",
    "Dark Purple",
    "Dark Red",
    "Dark Tan",
    "Green",
    "Light Bluish Gray",
    "Light Gray",
    "Lime",
    "Magenta",
    "Medium Azure",
    "Medium Lime",
    "Medium Nougat",
    "Olive Green",
    "Orange",
    "Red",
    "Reddish Brown",
    "Sand Blue",
    "Sand Green",
    "Tan",
    "White",
    "Yellow",
    "Yellowish Green",
    "Trans-Black",
    "Trans-Bright Green",
    "Trans-Clear",
    "Trans-Dark Blue",
    "Trans-Dark Pink",
    "Trans-Green",
    "Trans-Light Blue",
    "Trans-Medium Blue",
    "Trans-Neon Green",
    "Trans-Neon Orange",
    "Trans-Neon Yellow",
    "Trans-Orange",
    "Trans-Purple",
    "Trans-Red",
    "Trans-Yellow",
    "Chrome Antique Brass",
    "Chrome Gold",
    "Chrome Silver",
    "Flat Silver",
    "Pearl Dark Gray",
    "Pearl Gold",
    "Pearl Light Gray",
    "Metallic Silver",
    "Glow In Dark Opaque",
    "Glow In Dark White",
    "Medium Lavender", // manually added from Batman
    "Light Aqua", // manually added from Batman
];

const KNOWN_BRICKLINK_TILE_COLOR_NAMES = [
    "Black",
    "Blue",
    "Bright Light Blue",
    "Bright Light Orange",
    "Bright Pink",
    "Coral",
    "Dark Blue",
    "Dark Bluish Gray",
    "Dark Brown",
    "Dark Orange",
    "Dark Red",
    "Dark Tan",
    "Lavender",
    "Light Bluish Gray",
    "Light Nougat",
    "Lime",
    "Medium Blue",
    "Medium Nougat",
    "Nougat",
    "Olive Green",
    "Orange",
    "Red",
    "Reddish Brown",
    "Sand Blue",
    "Tan",
    "White",
    "Yellow",
    "Trans-Black",
    "Trans-Bright Green",
    "Trans-Clear",
    "Trans-Dark Blue",
    "Trans-Dark Pink",
    "Trans-Green",
    "Trans-Light Blue",
    "Trans-Orange",
    "Trans-Purple",
    "Trans-Red",
    "Trans-Yellow",
    "Flat Silver",
    "Pearl Gold",
    "Satin Trans-Light Blue",
    "Satin White",
    "Glow In Dark White",
    "Glitter Trans-Clear",
    "Glitter Trans-Dark Pink",
    "Glitter Trans-Light Blue",
    "Dark Bluish Gray", // manually added from Warhol
    "Dark Pink", // manually added from Warhol
    "Magenta", // manually added from Warhol
    "Medium Azure", // manually added from Warhol
    "Neon Yellow", // manually added from dots
    "Dark Azure", // manually added from art project
    "Light Aqua", // manually added from art project
    "Bright Light Yellow", // manually added from art project
    "Bright Green", // manually added from art project
    "Dark Turquoise", // manually added from dots
    "Yellowish Green", // manually added from dots
];

const BRICKLINK_STUD_COLORS = ALL_BRICKLINK_SOLID_COLORS.filter((color) =>
    KNOWN_BRICKLINK_STUD_COLOR_NAMES.includes(color.name)
).sort((a, b) => {
    return a.name > b.name ? 1 : -1;
});

const BRICKLINK_TILE_COLORS = ALL_BRICKLINK_SOLID_COLORS.filter((color) =>
    KNOWN_BRICKLINK_TILE_COLOR_NAMES.includes(color.name)
).sort((a, b) => {
    return a.name > b.name ? 1 : -1;
});

const ADDITIONAL_COLORS = ["Very Light Gray"];
let ALL_VALID_BRICKLINK_COLORS = ALL_BRICKLINK_SOLID_COLORS.sort((a, b) => {
    return a.name > b.name ? 1 : -1;
});
// .filter(
//     color =>
//         KNOWN_BRICKLINK_STUD_COLOR_NAMES.includes(color.name) ||
//         KNOWN_BRICKLINK_TILE_COLOR_NAMES.includes(color.name) ||
//         ADDITIONAL_COLORS.includes(color.name)
// ).sort((a, b) => {
//     return a.name > b.name ? 1 : -1;
// });

const PIXEL_TYPE_OPTIONS = [
    {
        name: "1x1 Round Tile",
        number: 98138,
    },
    {
        name: "1x1 Round Plate",
        number: 4073,
    },
    {
        name: "1x1 Square Tile",
        number: "3070b",
    },
    {
        name: "1x1 Square Plate",
        number: 3024,
    },
    {
        name: "1x1 Square Brick",
        number: 3005,
    },
    {
        name: "Variable Tile",
        number: "variable_tile",
    },
    {
        name: "Variable Plate",
        number: "variable_plate",
    },
    {
        name: "Variable Brick",
        number: "variable_brick",
    },
];

// use this for instructions - we prioritize readability over accuracy here
const PIXEL_TYPE_TO_FLATTENED = {
    98138: 98138,
    4073: 98138,
    3024: "3070b",
    "3070b": "3070b",
    3005: "3070b",
    variable_tile: "variable_tile",
    variable_plate: "variable_tile",
    variable_brick: "variable_tile",
};
